export default function TicketsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g clipPath="url(#clip0_6531_1732)">
        <path
          d="M12.4467 15.5242L10.6131 16.0096C8.91592 16.459 8.0673 16.6836 7.40239 16.3156C6.7375 15.9477 6.51596 15.1308 6.07288 13.497L4.97634 9.4536C4.53327 7.8198 4.31173 7.00294 4.70134 6.3558C5.09095 5.70866 5.93956 5.484 7.6368 5.03467L10.637 4.24038C12.3343 3.79105 13.1828 3.56639 13.8478 3.93435C14.5126 4.30231 14.7342 5.11921 15.1772 6.75298L16.2781 10.8124C16.4665 11.5072 16.5608 11.8546 16.4572 12.1813M12.4467 15.5242C13.0108 15.3748 13.0153 15.3724 13.4539 14.9961L15.5118 13.2303C16.0731 12.7487 16.3537 12.5079 16.4572 12.1813M12.4467 15.5242C12.4467 15.5242 12.8878 12.0793 13.875 11.625C14.9949 11.1096 16.4572 12.1813 16.4572 12.1813"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M12.75 3.75089C12.7017 2.94585 12.568 2.43908 12.1863 2.07572C11.6017 1.51915 10.6635 1.51638 8.787 1.51083L5.46991 1.50103C3.59347 1.49549 2.65525 1.49271 2.07401 2.04583C1.49278 2.59895 1.49551 3.49194 1.50099 5.27794L1.51453 9.69803C1.52001 11.4841 1.52275 12.377 2.10738 12.9336C2.69201 13.4902 3.63023 13.493 5.50668 13.4985L6.01729 13.5"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_6531_1732">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
